import styled from 'styled-components';
import GDBREAKPOINTS from '@gameday/components/themes/breakpoints';

const { XS_MAX } = GDBREAKPOINTS;

export const UpcomingBattersContainer = styled.div`
    font-family: var(--gameday-primary-font);
    color: var(--gameday-primary-font-color);
    display: flex;
    justify-content: center;
    font-size: 12px;
    line-height: 12px;
    font-weight: 700;
    padding: 8px 0 0 0;
    margin-bottom: -8px;
    @media (max-width: ${XS_MAX}) {
        padding: 8px 0;
        margin-bottom: 0;
    }
`;

export const UpcomingBatterWrapper = styled.div`
    display:block;
`;

export const UpcomingLabel = styled.span`
    color: var(--gameday-secondary-font-color);
`;

export const UpcomingStats = styled.span`
    color: var(--gameday-primary-font-color);
`;

export const MainWrapper = styled.div`
    margin-top: 16px;
`;
